export const TRACK_BOTH_VISIT_AND_CONVERSION = 'both';
export const TRACK_CONVERSION_ONLY = 'conversion';
export const TRACK_VISIT_ONLY = 'visit';
